import React, {
	memo,
	useCallback,
	useMemo
} from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { Tab } from 'semantic-ui-react';

import { log } from '../../../../../services/utils';

import { useAuthState } from '../../../../../contexts/AuthContext';
import { useAdminState } from '../../../../../contexts/AdminContext';

import Actions from '../../../../Shared/Actions';
import HelpModal from '../../../../Shared/HelpModal';
import multiWordFilterFn from '../../../../Table/filterFunctions/multiWordFilterFn';
import PageHeader from '../../../../Shared/PageHeader';
import Table from '../../../../Table';
import TableRowActions from '../../../../Table/Cells/TableRowActions';

const ProgramsTab = ( { activeIndex } ) => {
	const history = useHistory();

	const { user: { permissions } } = useAuthState();
	const { user } = useAdminState();

	const onView = useCallback( ( { id } ) => {
		history.push( {
			pathname: `/operations/programs/${ id }`,
			state: {
				text: '\u2190\u00A0\u00A0Back to User',
				to: {
					pathname: `/administration/users/${ user?.id }`,
					state: { activeIndex }
				}
			}
		} );
	}, [
		activeIndex,
		history,
		user
	] );

	const tableRowActionsCell = useCallback( ( { row } ) => {
		const actions = [
			{
				action: onView,
				componentProps: { color: 'pink' },
				disable: !permissions.viewPrograms.canExecute,
				icon: 'search',
				permission: permissions.viewPrograms.isAvailable,
				text: 'View Program'
			}
		];

		return (
			<TableRowActions
				actions={ actions }
				row={ row.original }
			/>
		);
	}, [
		onView,
		permissions
	] );

	const columns = useMemo( () => [
		{
			accessor: 'name',
			Header: 'Program Name',
			filter: multiWordFilterFn,
			minWidth: 60
		}
	], [] );

	const actionColumn = useMemo( () => ( {
		id: 'id_actions',
		Cell: tableRowActionsCell,
		disableFilters: true,
		disableResizing: true,
		width: 100,
		minWidth: 100,
		maxWidth: 100
	} ), [ tableRowActionsCell ] );

	const renderColumns = useMemo(
		() => permissions.viewPrograms.isAvailable
			? [
				...columns,
				actionColumn
			]
			: columns,
		[
			actionColumn,
			columns,
			permissions
		]
	);

	return (
		<Tab.Pane as="div">
			{ log( 'ProgramsTab' ) }
			<Actions />
			<PageHeader
				title={
					<>
						<span>Programs</span>
						<HelpModal
							id={ 36 }
							triggerStyles={ { verticalAlign: 'top' } }
						/>
					</>
				}
			/>
			<div className="table-container">
				<Table
					columns={ renderColumns }
					data={ user.programs }
					showCount={ user.programs.length > 10 }
					showEmptyRows={ false }
					showPagination={ user.programs.length > 10 }
				/>
			</div>
		</Tab.Pane>
	);
};

ProgramsTab.propTypes = { activeIndex: PropTypes.number };

export default memo( ProgramsTab );
